import ResumeWebsite from './ResumeWebsite';
import './App.css';

function App() {
  return <ResumeWebsite />;
}

export default App;
